import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_information: { message: "idle" },
};

export const retrieve_tenant_information_Slice = createSlice({
 name: "retrieve_tenant_information",
 initialState,
 reducers: {
  success_retrieve_tenant_information: (state, action) => {
   state.retrieve_tenant_information = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_information: (state, action) => {
   state.retrieve_tenant_information = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_information: (state) => {
   state.retrieve_tenant_information = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_information: (state) => {
   state.retrieve_tenant_information = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_information, fail_retrieve_tenant_information, reset_retrieve_tenant_information, loading_retrieve_tenant_information } = retrieve_tenant_information_Slice.actions;

export default retrieve_tenant_information_Slice.reducer;